<template>
    <v-dialog
        v-model="showDialog"
        width="600"
    >
        <v-card>
            <v-form
                ref="form"
                @submit.prevent="submitForm"
            >
                <v-card-title
                    style="background-color: #009688; color: white;"
                >
                    Edit coverage: {{ data && data.DIAG_T ? data.DIAG_T : '' }}
                </v-card-title>
                <v-card-text>
                    <v-text-field
                        v-model.trim="editData.DIAG_T"
                        label="Diagnostic"
                        color="teal"
                        :rules="[v => v !== '' && v !== null && v !== undefined && /[a-zA-Z]/.test(v) || 'This field is required']"
                        clearable
                    />
                    <v-select
                        v-model.trim="editData.SCOPE"
                        label="Scope"
                        :items="scopeItem"
                        color="teal"
                        :rules="requiredField"
                        readonly
                        disabled
                    />
                    <v-text-field
                        ref="editcoverageminage"
                        v-model="editData.AGE_MN"
                        label="Min Age"
                        color="teal"
                        :rules="[
                            (v) => v !== undefined && v !== null && !isNaN(v) || 'Must be a number.',
                            (v) => v <= editData.AGE_MX || 'Must be less than or equal to Max Age'
                        ]"
                        suffix="y.o."
                        :readonly="String(editData.SCOPE).trim().toUpperCase() === 'MEMBER' ? true : false"
                        :disabled="String(editData.SCOPE).trim().toUpperCase() === 'MEMBER' ? true : false"
                    />
                    <v-text-field
                        ref="editcoveragemaxage"
                        v-model="editData.AGE_MX"
                        label="Max Age"
                        color="teal"
                        :rules="[
                            (v) => v !== undefined && v !== null && !isNaN(v) || 'Must be a number.',
                            (v) => Number(v) >= Number(editData.AGE_MN) || 'Must be greater than or equal to Min Age'
                        ]"
                        suffix="y.o."
                        :readonly="String(editData.SCOPE).trim().toUpperCase() === 'MEMBER' ? true : false"
                        :disabled="String(editData.SCOPE).trim().toUpperCase() === 'MEMBER' ? true : false"
                        hint="120 represents no upper age limit."
                    />
                    <v-select
                        v-model.trim="editData.SEX"
                        label="Gender"
                        :items="sexItem"
                        item-text="label"
                        item-value="value"
                        color="teal"
                        :rules="requiredField"
                        :readonly="String(editData.SCOPE).trim().toUpperCase() === 'MEMBER' ? true : false"
                        :disabled="String(editData.SCOPE).trim().toUpperCase() === 'MEMBER' ? true : false"
                        :clearable="String(editData.SCOPE).trim().toUpperCase() === 'ACCOUNT' ? true : false"
                    >
                        <template #selection="{ item }">
                            <v-icon :color="item.value === 'F' ? 'pink' : item.value === 'M' ? 'blue' : ''">
                                {{ item.value === 'F' ? mdiGenderFemale : item.value === 'M' ? mdiGenderMale : '' }}
                            </v-icon> &nbsp;{{ item.label }}
                        </template>
                        <template #item="{ item }">
                            <v-icon :color="item.value === 'F' ? 'pink' : item.value === 'M' ? 'blue' : ''">
                                {{ item.value === 'F' ? mdiGenderFemale : item.value === 'M' ? mdiGenderMale : '' }}
                            </v-icon> &nbsp;{{ item.label }}
                        </template>
                    </v-select>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        color="teal darken-1"
                        outlined
                        @click="showDialog = false"
                    >
                        close
                    </v-btn>
                    <v-btn
                        type="submit"
                        color="teal darken-1 white--text"
                    >
                        save
                    </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import {
    mdiGenderFemale,
    mdiGenderMale
} from '@mdi/js'

export default {
    props: ['show', 'data'],
    data: ()=>({
        mdiGenderFemale,
        mdiGenderMale,
        isMaxAgeEditable: false,
        sexItem: [
            { label: 'All', value: 'A' },
            { label: 'Male', value: 'M' },
            { label: 'Female', value: 'F' }
        ],
        editData: {
            ID: null,
            ACCT_N: null,
            ACCT_M: null,
            DIAG_T: null,
            AGE_MN: null,
            AGE_MX: null,
            SEX: null,
            SCOPE: null
        },
        scopeItem: [
            'ACCOUNT',
            'MEMBER'
        ],
        requiredField: [v => v !== '' && v !== null && v !== undefined || 'This field is required'],
        isValidAge: [value => {
            if (value === '' || value === null) return true
            const regex = /^(0|[1-9]\d*)$/
            return regex.test(value) || 'Enter a non-negative whole number'
        }]
    }),
    computed: {
        showDialog: {
            get() {
                if (this.show) this.initData()
                return this.show
            },
            set() {
                this.$emit('closeDialog')
            }
        }
    },
    watch: {
        'editData.AGE_MN'() {
            this.$nextTick(() => {
                this.$refs['editcoverageminage'].validate()
                this.$refs['editcoveragemaxage'].validate()
            })
        },
        'editData.AGE_MX'() {
            this.$nextTick(() => {
                this.$refs['editcoverageminage'].validate()
                this.$refs['editcoveragemaxage'].validate()
            })
        }
    },
    methods: {
        ...mapActions(['editAccountCoverage', 'suggestAcuDiagnostics']),
        editMaxAge(age) {
            if (age === 120) {
                this.editData.AGE_MX = 120
            }
            this.isMaxAgeEditable = !this.isMaxAgeEditable
        },
        submitForm() {
            if (this.$refs && this.$refs.form.validate()) {
                this.editAccountCoverage(this.editData).then(() => this.suggestAcuDiagnostics())
            }
        },
        initData() {
            if (this.$refs && this.$refs.form) {
                this.$refs.form.resetValidation()
            }
            this.editData = structuredClone(this.data)
        }
    }
}
</script>
